// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_List from "../Specular.FRP.List/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var Item = function (x) {
    return x;
};
var Mapping = function (x) {
    return x;
};
var queryArrayTupleMapping = function (dictOrd) {
    return function (dictQuery) {
        return {
            queryWith: function (strictness) {
                return function (v) {
                    return Restaumatic_Form.annotatedFinal("query Mapping")(Restaumatic_Form_Final.makeFinalV(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.items))(function (items) {
                        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.keys)))(function (keys_) {
                            var entryResults = Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray)(keys_)(function (k) {
                                var v1 = Data_Map_Internal.lookup(dictOrd)(k)(items);
                                if (v1 instanceof Data_Maybe.Just) {
                                    return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v2) {
                                        return function (v3) {
                                            var handleInvalid = (function () {
                                                var $107 = Data_Eq.eq(Restaumatic_Form.eqStrictness)(strictness)(Restaumatic_Form.Lax.value);
                                                if ($107) {
                                                    return Data_Validation_Semigroup.validation(function (v4) {
                                                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors))(Data_Maybe.Nothing.value);
                                                    })(Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors)));
                                                };
                                                return Control_Category.identity(Control_Category.categoryFn);
                                            })();
                                            var v4 = Data_Newtype.unwrap()(v2);
                                            if (v4 instanceof Data_Either.Right && !v4.value0) {
                                                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors))(Data_Maybe.Nothing.value);
                                            };
                                            return handleInvalid(Control_Apply.apply(Data_Validation_Semigroup.applyV(Restaumatic_Form_Final.semigroupFormErrors))(Data_Functor.map(Data_Validation_Semigroup.functorV)(function (v5) {
                                                return function (v6) {
                                                    return new Data_Maybe.Just(new Data_Tuple.Tuple(k, v5));
                                                };
                                            })(v3))(v2));
                                        };
                                    })(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v1.value0.presentWhen))(Restaumatic_Form_Final.unFinalV)))(Restaumatic_Form_Final.unFinalV(Restaumatic_Form.queryWith(dictQuery)(strictness)(v1.value0.subform)));
                                };
                                if (v1 instanceof Data_Maybe.Nothing) {
                                    return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.internalError("Mapping key not found")));
                                };
                                throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 183, column 9 - line 205, column 77): " + [ v1.constructor.name ]);
                            });
                            return Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
                                var $164 = Data_Functor.map(Data_Validation_Semigroup.functorV)(Data_Array.catMaybes);
                                var $165 = Data_Traversable.sequence(Data_Traversable.traversableArray)(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Final.semigroupFormErrors));
                                return function ($166) {
                                    return $164($165($166));
                                };
                            })())(entryResults);
                        });
                    })));
                };
            }
        };
    };
};
var queryMapMapping = function (dictOrd) {
    return function (dictQuery) {
        return {
            queryWith: function (strictness) {
                return function (field) {
                    return Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray))(Restaumatic_Form.queryWith(queryArrayTupleMapping(dictOrd)(dictQuery))(strictness)(field));
                };
            }
        };
    };
};
var hasFieldIdMapping = {
    getFieldId: function (v) {
        return Restaumatic_Form.fieldPathToString(v.name);
    }
};
var hasFieldIdItem = function (dictShow) {
    return {
        getFieldId: function (v) {
            return Restaumatic_Form.getFieldId(hasFieldIdMapping)(v.parent) + ("." + Data_Show.show(dictShow)(v.key));
        }
    };
};
var subform = function (v) {
    return v.subform;
};
var querySerializedMapMapping = function (dictOrd) {
    return function (dictQuery) {
        return {
            queryWith: function (strictness) {
                var $167 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Map_Serialized.SerializedMap);
                var $168 = Restaumatic_Form.queryWith(queryMapMapping(dictOrd)(dictQuery))(strictness);
                return function ($169) {
                    return $167($168($169));
                };
            }
        };
    };
};
var queryItem = function (dictQuery) {
    return {
        queryWith: function (s) {
            return function (v) {
                return Restaumatic_Form.queryWith(dictQuery)(s)(v.subform);
            };
        }
    };
};
var presentWhen = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(v1.presentWhen)(v));
    };
};
var newtypeMapping = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeItem = {
    Coercible0: function () {
        return undefined;
    }
};
var mergeItem = function (dictMerge) {
    return {
        merge: function (x) {
            return function (v) {
                return Restaumatic_Form.merge(dictMerge)(x)(v.subform);
            };
        }
    };
};
var makeItem = function (dictShow) {
    return function (dictMakeEmpty) {
        return function (dictAddContext) {
            return function (v) {
                return function (key1) {
                    return function __do() {
                        var subform1 = Restaumatic_Form.makeEmptyImpl(dictMakeEmpty)({
                            name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.name)([ Data_Show.show(dictShow)(key1) ])
                        })();
                        var presentWhen1 = Specular_Ref.newRef(Effect_Class.monadEffectEffect)(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(true))();
                        var v1 = Specular_FRP_Host.runHost(Control_Bind.bind(Specular_FRP_Host.bindHost)(Specular_Ref.readRef(Specular_FRP_Host.monadEffectHost)(v.init))(function (init) {
                            return Restaumatic_Form.defineForm(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost))(init({
                                parent: v,
                                key: key1,
                                subform: subform1,
                                cleanup: Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit),
                                presentWhen: presentWhen1
                            }));
                        }))();
                        var ctx = Specular_Ref.readRef(Effect_Class.monadEffectEffect)(v.context)();
                        Restaumatic_Form.addContext(dictAddContext)(ctx)(subform1)();
                        return {
                            parent: v,
                            key: key1,
                            subform: subform1,
                            cleanup: v1.value1,
                            presentWhen: presentWhen1
                        };
                    };
                };
            };
        };
    };
};
var keys = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(v1.keys)(v));
    };
};
var keyOptions = function (v) {
    return function (v1) {
        return Restaumatic_Form.define1(v1.editableKeys)(Restaumatic_Form.options()(v));
    };
};
var key = function (v) {
    return v.key;
};
var itemForKey = function (dictOrd) {
    return function (v) {
        return function (k) {
            return Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
                return Data_Map_Internal.lookup(dictOrd)(k)(v1);
            })(Specular_Ref.value(v.items));
        };
    };
};
var item = function (v) {
    return function (v1) {
        return Control_Bind.discard(Control_Bind.discardUnit)(Restaumatic_Form.bindFormDefM)(Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Restaumatic_Form.writeRef(v1.init)(v)))(function () {
            return Control_Bind.bind(Restaumatic_Form.bindFormDefM)(Effect_Class.liftEffect(Restaumatic_Form.monadEffectFormDefM)(Specular_Ref.readRef(Effect_Class.monadEffectEffect)(v1.items)))(function (items) {
                return Data_Foldable.traverse_(Restaumatic_Form.applicativeFormDefM)(Data_Map_Internal.foldableMap)(v)(items);
            });
        });
    };
};
var isSelectFieldMappingItem = function (dictIsSelectField) {
    return {
        selectWriteValue: function (f) {
            return Restaumatic_Form.selectWriteValue(dictIsSelectField)(subform(f));
        },
        selectReadValue: function (f) {
            return Restaumatic_Form.selectReadValue(dictIsSelectField)(subform(f));
        },
        selectGetOptions: function (f) {
            return Restaumatic_Form.selectGetOptions(dictIsSelectField)(subform(f));
        },
        selectTouch: function (f) {
            return Restaumatic_Form.selectTouch(dictIsSelectField)(subform(f));
        }
    };
};
var hasFieldItem = function (dictHasField) {
    return {
        getField: function (label) {
            return function (v) {
                return Data_Record.getField(dictHasField)(label)(v.subform);
            };
        }
    };
};
var hasErrorsWithExtra = function (dictHasErrors) {
    return {
        displayedErrors: function (f) {
            return Restaumatic_Form.displayedErrors(dictHasErrors)(subform(f));
        }
    };
};
var eqItem = {
    eq: Unsafe_Reference.unsafeRefEq
};
var ensureItems = function (dictOrd) {
    return function (dictShow) {
        return function (dictMakeEmpty) {
            return function (dictAddContext) {
                return function (v) {
                    return function (keys1) {
                        return function __do() {
                            var items$prime = Specular_Ref.read(Effect_Class.monadEffectEffect)(v.items)();
                            var newItems = Data_Functor.map(Effect.functorEffect)(Data_Array.catMaybes)(Data_Traversable["for"](Effect.applicativeEffect)(Data_Traversable.traversableArray)(keys1)(function (v1) {
                                return function __do() {
                                    var v2 = (function () {
                                        var v2 = Data_Map_Internal.lookup(dictOrd)(v1.value0)(items$prime);
                                        if (v2 instanceof Data_Maybe.Just) {
                                            return new Data_Tuple.Tuple(v2.value0, Data_Maybe.Nothing.value);
                                        };
                                        if (v2 instanceof Data_Maybe.Nothing) {
                                            var item1 = makeItem(dictShow)(dictMakeEmpty)(dictAddContext)(v)(v1.value0)();
                                            return new Data_Tuple.Tuple(item1, new Data_Maybe.Just(new Data_Tuple.Tuple(v1.value0, item1)));
                                        };
                                        throw new Error("Failed pattern match at Restaumatic.Form.Mapping (line 135, column 27 - line 140, column 50): " + [ v2.constructor.name ]);
                                    })();
                                    v1.value1(v2.value0)();
                                    return v2.value1;
                                };
                            }))();
                            return Control_Applicative.unless(Effect.applicativeEffect)(Data_Array["null"](newItems))(Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.items)(function (oldItems) {
                                return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (m) {
                                    return function (v1) {
                                        return Data_Map_Internal.insert(dictOrd)(v1.value0)(v1.value1)(m);
                                    };
                                })(oldItems)(newItems);
                            }))();
                        };
                    };
                };
            };
        };
    };
};
var makeEmpty = function (dictShow) {
    return function (dictOrd) {
        return function (dictMakeEmpty) {
            return function (dictAddContext) {
                return {
                    makeEmptyImpl: function (opts) {
                        return function __do() {
                            var items = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Map_Internal.empty)();
                            var init = Specular_Ref["new"](Effect_Class.monadEffectEffect)(function (v) {
                                return Control_Applicative.pure(Restaumatic_Form.applicativeFormDefM)(Data_Unit.unit);
                            })();
                            var editableKeys1 = Restaumatic_Form.makeEmptyImpl(Restaumatic_Form.makeEmptyFormField)({
                                name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(opts.name)([ "__keys__" ])
                            })();
                            Restaumatic_Form.merge(Restaumatic_Form.mergeFormField(Type_Equality.refl))([  ])(editableKeys1)();
                            var keys1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form.queryLaxWithDefault(Restaumatic_Form.queryFormFieldI(Type_Equality.refl))(Data_Monoid.mempty(Data_Monoid.monoidArray))(editableKeys1))();
                            var context = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Monoid.mempty(Data_Vault.monoidVault))();
                            var m = {
                                name: opts.name,
                                items: items,
                                init: init,
                                context: context,
                                editableKeys: editableKeys1,
                                keys: keys1
                            };
                            Specular_FRP_Host.runHost(Data_Function.flip(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost)))(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(keys1)))(function (ks) {
                                return ensureItems(dictOrd)(dictShow)(dictMakeEmpty)(dictAddContext)(m)(Data_Functor.mapFlipped(Data_Functor.functorArray)(ks)(function (k) {
                                    return new Data_Tuple.Tuple(k, function (v) {
                                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                                    });
                                }));
                            }))();
                            return m;
                        };
                    }
                };
            };
        };
    };
};
var mergeMapMapping = function (dictOrd) {
    return function (dictShow) {
        return function (dictMerge) {
            return function (dictMakeEmpty) {
                return function (dictAddContext) {
                    return {
                        merge: function (m) {
                            return function (v) {
                                return function __do() {
                                    ensureItems(dictOrd)(dictShow)(dictMakeEmpty)(dictAddContext)(v)(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(m))(function (v1) {
                                        return new Data_Tuple.Tuple(v1.value0, Restaumatic_Form.merge(mergeItem(dictMerge))(v1.value1));
                                    }))();
                                    return Restaumatic_Form.merge(Restaumatic_Form.mergeFormField(Type_Equality.refl))(Data_Array.fromFoldable(Data_Set.foldableSet)(Data_Map.keys(m)))(v.editableKeys)();
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var mergeSMapMapping = function (dictOrd) {
    return function (dictShow) {
        return function (dictMerge) {
            return function (dictMakeEmpty) {
                return function (dictAddContext) {
                    return {
                        merge: function (m) {
                            return function (ff) {
                                return Restaumatic_Form.merge(mergeMapMapping(dictOrd)(dictShow)(dictMerge)(dictMakeEmpty)(dictAddContext))(Data_Newtype.unwrap()(m))(ff);
                            };
                        }
                    };
                };
            };
        };
    };
};
var editableKeys = function (v) {
    return v.editableKeys;
};
var dumpStateMapping = function (dictEncodeWithOptions) {
    return function (dictDumpState) {
        return {
            dumpState: function (v) {
                return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.items))(function (items) {
                    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                        reflectSymbol: function () {
                            return "subform";
                        }
                    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))({
                        reflectSymbol: function () {
                            return "key";
                        }
                    })(dictEncodeWithOptions))))))))(Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordSingle({
                        reflectSymbol: function () {
                            return "items";
                        }
                    })()(Specular_FRP_Base.functorDynamic)()())({
                        items: Data_Traversable["for"](Specular_FRP_Base.applicativeDynamic)(Data_Traversable.traversableArray)(Data_Array.fromFoldable(Data_Map_Internal.foldableMap)(items))(function (v1) {
                            return Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordCons({
                                reflectSymbol: function () {
                                    return "key";
                                }
                            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                                reflectSymbol: function () {
                                    return "subform";
                                }
                            })()(Specular_FRP_Base.functorDynamic)()())()())({
                                key: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(v1.key),
                                subform: Restaumatic_Form.dumpState(dictDumpState)(v1.subform)
                            });
                        })
                    }));
                });
            }
        };
    };
};
var displayedItems = function (dictOrd) {
    return function (v) {
        return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
            return function (v2) {
                return Data_Array.mapMaybe(function (k) {
                    return Data_Map_Internal.lookup(dictOrd)(k)(v1);
                })(v2);
            };
        })(Specular_Ref.value(v.items)))(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(v.keys)));
    };
};
var displayWithIndex = function (dictOrd) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (l) {
                return function (renderItem) {
                    return Specular_FRP_List.dynamicListWithIndex_(dictMonadFRP)(dictMonadReplace)(displayedItems(dictOrd)(l))(function (ix) {
                        return function (ditem) {
                            return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(ditem)(renderItem(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(ix)));
                        };
                    });
                };
            };
        };
    };
};
var displayKey = function (dictOrd) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (ff) {
                return function (k) {
                    return function (display1) {
                        return Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data_Maybe.eqMaybe(eqItem))(itemForKey(dictOrd)(ff)(k))(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(display1));
                    };
                };
            };
        };
    };
};
var display = function (dictOrd) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (l) {
                return function (renderItem) {
                    return Specular_FRP_Extra.withUniqDynamic_(dictMonadFRP)(dictMonadReplace)(Data_Eq.eqArray(eqItem))(displayedItems(dictOrd)(l))(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableArray)(renderItem));
                };
            };
        };
    };
};
var deleteItem = function (dictEq) {
    return function (v) {
        return Restaumatic_Form.modifyValidValue(v.parent.editableKeys)((function () {
            var $170 = Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray));
            return function ($171) {
                return (function (a) {
                    return Data_Maybe.fromMaybe(a)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.findIndex(Data_Eq.eq(dictEq)(v.key))(a))(function (index) {
                        return Data_Array.deleteAt(index)(a);
                    }));
                })($170($171));
            };
        })());
    };
};
var deleteItemCb = function (dictEq) {
    return function (item1) {
        return deleteItem(dictEq)(item1);
    };
};
var addItem = function (dictMakeEmpty) {
    return function (dictAddContext) {
        return function (dictOrd) {
            return function (dictShow) {
                return function (field) {
                    return function (key1) {
                        return function __do() {
                            var item1 = makeItem(dictShow)(dictMakeEmpty)(dictAddContext)(field)(key1)();
                            Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)((Data_Newtype.unwrap()(field)).items))(Data_Map_Internal.insert(dictOrd)(key1)(item1))();
                            Restaumatic_Form.modifyValidValue((Data_Newtype.unwrap()(field)).editableKeys)((function () {
                                var $172 = Data_Maybe.fromMaybe([  ]);
                                return function ($173) {
                                    return (function (v) {
                                        return Data_Semigroup.append(Data_Semigroup.semigroupArray)(v)([ key1 ]);
                                    })($172($173));
                                };
                            })())();
                            return item1;
                        };
                    };
                };
            };
        };
    };
};
var addContextMapping = function (dictAddContext) {
    return {
        addContext: function (ctx) {
            return function (v) {
                return function __do() {
                    Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(v.context))(function (v1) {
                        return Data_Semigroup.append(Data_Vault.semigroupVault)(ctx)(v1);
                    })();
                    var items = Specular_Ref.readRef(Effect_Class.monadEffectEffect)(v.items)();
                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Map_Internal.foldableMap)(items)(function (item1) {
                        return Restaumatic_Form.addContext(dictAddContext)(ctx)(subform(item1));
                    })();
                };
            };
        }
    };
};
export {
    Mapping,
    Item,
    key,
    subform,
    item,
    presentWhen,
    keys,
    keyOptions,
    editableKeys,
    ensureItems,
    makeItem,
    itemForKey,
    displayKey,
    displayedItems,
    display,
    displayWithIndex,
    deleteItem,
    deleteItemCb,
    addItem,
    newtypeMapping,
    hasFieldIdMapping,
    newtypeItem,
    hasFieldItem,
    queryItem,
    mergeItem,
    eqItem,
    isSelectFieldMappingItem,
    hasErrorsWithExtra,
    hasFieldIdItem,
    makeEmpty,
    mergeMapMapping,
    mergeSMapMapping,
    queryArrayTupleMapping,
    queryMapMapping,
    querySerializedMapMapping,
    addContextMapping,
    dumpStateMapping
};
//# sourceMappingURL=index.js.map
